import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SsInventoryService } from 'shared/services/SS-Inventory/ss-inventory.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';
import * as _ from 'lodash';
import { AppComponent } from 'app/app.component';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';
import { environment } from 'environments/environment';
import { MatDialog } from '@angular/material';
import { ViewScheduleComponent } from 'shared/reusable/view-schedule/view-schedule.component';

@Component({
  selector: 'app-choose-seats',
  templateUrl: './choose-seats.component.html',
  styleUrls: ['./choose-seats.component.css']
})

export class ChooseSeatsComponent implements OnInit {
  loading: boolean;
  disableSeatSelection: Boolean = false;
  seat_count_selected: number;
  teamSelected: any;
  priceRanges: any = [];
  seats: any = [];
  ALL_SECTIONS: any = [];
  buttonLabels: any = [];
  seatForm: FormGroup;
  eventName: string;
  selectedSections: any;
  index: number;
  imageURL: string = environment.URL_TEAM_IMAGES;

  constructor(
    private is: SsInventoryService,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private data: DataSharingService,
    private app: AppComponent,
    private alertService: AlertPopupService
  ) { this.route.queryParams.subscribe(params => { this.eventName = params.eventName; }); }

  ngOnInit() {
    this.loading = true;
    this.data.changeTitle('CHOOSE SEAT');
    this.seatForm = new FormGroup({
      numberOfSeats: new FormControl('', Validators.required),
      section: new FormControl('', Validators.required),
      row: new FormControl('', Validators.required),
      seats: new FormControl('', Validators.required),
      buttonLabel: new FormControl('', Validators.required),
    });
    this.is.getPackagedata(this.eventName).subscribe(res => {
      if (res.teams.event_name === 'DEPOSIT') {
        this.alertService.errorAlertWithResult('Seat Selection not yet availabble for this Season Ticket. ', 'Go Back', '/new-group');
      }
      this.teamSelected = res.teams;
      this.getSeats();
      this.loading = false;
    }, err => {
      this.loading = false;
      this.alertService.errorAlertWithResult(err.error.message, 'Go Back', '/new-group');
    });
  }

  chooseSeatCount(count) {
    this.app.toggleLoadingMsg('Getting Price Range');
    this.is.getPriceRange(this.teamSelected.vendor_id_fk, this.teamSelected.event_name).subscribe(res => {
      this.seatForm.get('numberOfSeats').setValue(count);
      this.seat_count_selected = count;
      if (this.seatForm.get('section').value) {
        this.seatForm.get('row').setValue('');
        this.seatForm.get('buttonLabel').setValue('');
        this.seatForm.get('seats').setValue('');
        this.choosePrice(this.seatForm.get('section').value);
      }
      this.priceRanges = res.pricerange;
      this.app.dismissLoading();
    }, err => {
      const err1 = JSON.parse(err._body);
      this.app.dismissLoading();
      this.alertService.errorAlert(err1.error.message);
    });
  }

  choosePrice(section_selected) {
    this.app.toggleLoadingMsg('Fetching best seats');
    const input = {
      event_name: this.teamSelected.event_name,
      vendor_id: this.teamSelected.vendor_id_fk,
      seats_needed: this.seat_count_selected,
      num_seats_sec: (Number(this.seat_count_selected) * 2),
      section_name: section_selected
    };
    this.is.getBestSeats(input).subscribe(res => {
      this.app.dismissLoading();
      if (res.seat_block === null || res.seat_block === 'Error-Seat Not Found 2') {
        if (res.seat_block === null) {
          this.alertService.errorAlert('Did you select how many seats?');
        } else {
          if (res.seat_block === 'Error-Seat Not Found 2') {
            this.alertService.errorAlert(res.seat_block);
          }
        }
      } else {
        this.seatForm.get('section').setValue(section_selected);
        this.convertBlocksCombos(res.seat_block);
      }
    }, err => {
      this.app.dismissLoading();
      this.alertService.errorAlert('Please check your seat selection and try again. ');
    });
  }

  viewSchedule() {
    const dialogRef = this.dialog.open(ViewScheduleComponent, {
      data: {
        eventName: this.teamSelected.event_name,
        teamImage: this.teamSelected.team_thumb_img,
        teamName: this.teamSelected.team_name,
        teamDescription: this.teamSelected.description
      },
      width: '70%',
    });
  }

  convertBlocksCombos(seat_blocks: any = []) {
    this.ALL_SECTIONS = [];
    seat_blocks.forEach((block) => {
      const seatsArr = (block.combos);
      const seatIds = block.seat_id;
      const seatIdsArray = seatIds;
      seatsArr.forEach((seatCombo, combosIndex) => {
        const seatArr = (seatCombo);
        const seatIdsArr = seatIdsArray[combosIndex];
        const oneSection = {
          section: block.section_name,
          row: block.row_name.replace(/\s/g, ''),
          seats: seatCombo.toString(),
          display_price: block.price * seatArr.length,
          price: block.price, // single ticket price to do
          increment: block.seat_increment,
          seats_arr: seatArr,
          seat_ids_arr: seatIdsArr,
          first_seat: seatArr[0],
          last_seat: seatArr[(seatArr.length - 1)],
          num_seats: seatArr.length,
          price_code: block.price_code.replace(/\s/g, ''),
          ticket_type_name: block.ticket_type_name,
          ticket_type_code: block.ticket_type_code
        };
        this.ALL_SECTIONS.push(oneSection);
      });
    });
  }

  chooseSeatAndRow(section) {
    this.selectedSections = section;
    this.buttonLabels = [
      'Me + 1 Friend',
      'Me + 2 Friends',
      'Me + 3 Friends'
    ];
    this.seatForm.get('row').setValue(section.row);
    this.seatForm.get('seats').setValue(section.seats);
    // TODO - just me based on team_inventory flag
    this.buttonLabels = [
      'Me + 1 Friend - $' + (Number(section.display_price) / 2).toFixed(2) + ' each',
      'Me + 2 Friends - $' + (Number(section.display_price) / 3).toFixed(2) + ' each',
      'Me + 3 Friends - $' + (Number(section.display_price) / 4).toFixed(2) + ' each'
    ];
  }

  selectLabel(buttonLabel, index) {
    this.index = index;
    this.seatForm.get('buttonLabel').setValue(buttonLabel);
  }

  proceed() {
    if (this.seatForm.valid) {
      this.app.toggleLoadingMsg('Loading');
      this.is.holdSeatForPreauth(this.selectedSections, this.index, this.teamSelected.team_id,
        this.teamSelected.event_name).subscribe(res => {
          this.app.dismissLoading();
          const params = {
            seat: res.seat,
            hold_data: res.hold_data,
            description: this.teamSelected.short_description,
            team_id: this.teamSelected.team_id,
            team_name: this.teamSelected.team_name,
            teamSelected: this.teamSelected,
            display_data: res.display_data
          };
          this.data.holdDataService(params);
          /* localStorage.setItem('holdSeatRes', JSON.stringify(params)); */
          this.router.navigate(['/new-group/leader-charge-card']);
        }, err => {
          this.app.dismissLoading();
          this.alertService.errorAlert('This seat is no longer available. Please try another.');
        });
    } else {
      this.markFormGroupTouch(this.seatForm);
    }
  }

  private markFormGroupTouch(form: FormGroup) {
    (<any>Object).values(form.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouch(control);
      }
    });
  }

  back() {
    this.router.navigate(['/new-group/choose-season']);
  }

  getSeats() {
    this.seats = [
      {
        seat_count_txt: '1 Seat',
        seat_count_int: 1
      },
      {
        seat_count_txt: '2 Seats',
        seat_count_int: 2
      },
      {
        seat_count_txt: '3 Seats',
        seat_count_int: 3
      },
      {
        seat_count_txt: '4 Seats',
        seat_count_int: 4
      },
      {
        seat_count_txt: '5 Seats',
        seat_count_int: 5
      },
      {
        seat_count_txt: '6 Seats',
        seat_count_int: 6
      },
      {
        seat_count_txt: '7 Seats',
        seat_count_int: 7
      },
      {
        seat_count_txt: '8 Seats',
        seat_count_int: 8
      },
      {
        seat_count_txt: '9 Seats',
        seat_count_int: 9
      }];
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/group/components/choose-seats/choose-seats.component.ts